<template>
  <div v-if="isIntegrationCompleted">
    <CompleteIntegration :text-complete="textComplete" />
  </div>
  <div v-else class="template">
    <a class="link">
      <router-link to="/channels/setup"> <LeftOutlined /> Regresar a los canales </router-link>
    </a>
    <div class="container">
      <p class="title">SMS</p>
      <p class="description">¡Activa tu canal SMS doble vía para conversar con tus clientes!</p>
      <div class="card-details">
        <p class="description">
          • La numeración mostrada al enviar es aleatoria. <br />
          • La efectividad de entrega es del 99%. <br />
          • Los resultados, en tiempos y estados, dependen del operador móvil.
          <br />
          • Comunicación bidireccional.
        </p>
      </div>
      <div class="card-active">
        <a-row :gutter="4" type="flex" justify="space-around" align="middle">
          <a-col span="1"><InfoCircleOutlined /></a-col>
          <a-col span="21">
            <span>
              Los SMS enviados por los agentes desde Workspace podrán ser respondidos. Deshabilitar
              esta opción si deseas que estos SMS solo sean informativos.
            </span>
          </a-col>
          <a-col span="2">
            <a-form
              layout="vertical"
              hide-required-mark
              ref="formRef"
              :model="formState"
              :rules="rules"
            >
              <a-form-item name="workspace">
                <a-switch v-model:value="formState.workspace" size="small" />
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </div>
      <div class="btns">
        <a-button class="btn-return" @click="handleCancel">Atras</a-button>

        <a-button key="submit" class="btn" type="primary" @click="handleOk"> Activar </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import CompleteIntegration from "@/app/channels/components/templates/SocialChannels/CompleteIntegration.vue";
import { defineComponent, ref, reactive, toRaw } from "vue";
import { InfoCircleOutlined, LeftOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  name: "SmsChannels",
  components: {
    CompleteIntegration,
    InfoCircleOutlined,
    LeftOutlined,
  },
  setup() {
    const formRef = ref();
    const formState = reactive({
      workspace: "",
    });
    const rules = {
      workspace: [{ valuePropName: "checked" }],
    };
    return {
      rules,
      formState,
      formRef,
    };
  },

  data() {
    return {
      isIntegrationCompleted: false,
      textComplete: {
        channel: "sms",
        title: "SMS",
        description: "Tu canal se integró correctamente con WhatsApp",
      },
    };
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        const data = {
          channel: 2,
          data_parameters: {
            ...toRaw(this.formState),
          },
          // queue: 1,
          provider: 5,
        };
        this.handleCreateNewChannel(data);
      });
    },
    async handleCreateNewChannel(data) {
      try {
        await this.$store.dispatch("createNewChannel", data);
        this.isIntegrationCompleted = true;
        this.formRef.resetFields();
      } catch (error) {
        const errorMessage = error?.getErrorMessage() || "Ha courrido un error";

        this.$message.error(errorMessage);
      }
    },
    handleCancel() {
      this.$router.push(`/channels/setup`);
    },
  },
});
</script>

<style lang="sass" scoped>
.template
  padding: 32px 20px 8px
.container
  margin: auto
  width: 540px
.link
  color: $blue-6
  margin-bottom: 0px
  margin-left: $margin-tiny
  font-weight: normal
.title
  font-weight: 600
  font-size: $font-large
  line-height: 28px
  text-align: center
  color: $gray-9
  margin-bottom: $margin-tiny
  margin-top: 30px
.description
  font-size: $font-normal
  line-height: 22px
  color: $gray-9
  text-align: center
.card-details
  background: $geekblue-2
  border: 1px solid $blue-1
  box-sizing: border-box
  border-radius: 2px
  padding: $padding-medium
  width: 100%
  margin-top: 28px
  p
    text-align: left
    margin-bottom: 0px
.card-active
  background: $white
  border: 1px solid $gray-4
  box-sizing: border-box
  border-radius: 8px
  margin-top: $margin-small
  padding: 8px 0px 8px 12px
  margin-bottom: $margin-large
  span
    font-size: $font-small
.btns
  display: flex
  justify-content: flex-end
  button
    border-radius: 2px
  .btn-return
    margin-right: 12px
</style>
